import { App } from "./src/app";

// Trigger deployment commit: 3
export default function AppEntry() {
  return <App />;
}
